import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import TagManager from 'react-gtm-module';
import { authConfig, gmtConfig, rumConfig, katalonConfig } from './env-exports';
import { ErrorHandler } from '@/components';
import { RumClient } from '@/services';
import App from './App';
import './index.css';

if (katalonConfig.enabled) {
  const script = document.createElement('script');
  script.src = 'https://static.katalon.com/libs/traffic-agent/v1/traffic-agent.min.js';
  script.setAttribute('client-code', 'KA-1636833-01');
  script.defer = true;
  script.async = true;
  document.head.appendChild(script);
}

if (gmtConfig.enabled) {
  TagManager.initialize(gmtConfig.config);
}
if (rumConfig.appMonitorId) {
  RumClient.initialise({
    appMonitorId: rumConfig.appMonitorId,
    identityPoolId: authConfig.identityPoolId,
    guestRoleArn: authConfig.unauthRoleArn,
    sessionSampleRate: 1,
    region: authConfig.identityPoolRegion,
    urlsToTrace: [/\/api\/trpc/],
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary FallbackComponent={ErrorHandler}>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
